import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import './AdminLayout.css';

const AdminLayout = () => {
    const { isDarkTheme } = useTheme();

    return (
        <div className={`admin-layout ${isDarkTheme ? 'dark' : 'light'}`}>
            <aside className="admin-sidebar card">
                <div className="admin-sidebar-header">
                    <h2>Admin Panel</h2>
                </div>
                <nav className="admin-nav">
                    <NavLink to="/admin" end className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`}>
                        <span className="admin-nav-icon">📊</span>
                        Dashboard
                    </NavLink>
                    <NavLink to="/admin/exercises" className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`}>
                        <span className="admin-nav-icon">📝</span>
                        Exercises
                    </NavLink>
                    <NavLink to="/admin/exercises/new" className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`}>
                        <span className="admin-nav-icon">➕</span>
                        Create Exercise
                    </NavLink>
                    <NavLink to="/admin/lessons/new" className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`}>
                        <span className="admin-nav-icon">📖</span>
                        Create Lesson
                    </NavLink>
                    <NavLink to="/admin/units" className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`}>
                        <span className="admin-nav-icon">📦</span>
                        Units
                    </NavLink>
                    <NavLink to="/admin/users" className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`}>
                        <span className="admin-nav-icon">👥</span>
                        Users
                    </NavLink>
                </nav>
                <div className="admin-sidebar-footer">
                    <NavLink to="/dashboard" className="admin-nav-link back-link">
                        <span className="admin-nav-icon">←</span>
                        Back to App
                    </NavLink>
                </div>
            </aside>
            <main className="admin-main">
                <Outlet />
            </main>
        </div>
    );
};

export default AdminLayout;
